import React from 'react'
import styled, { keyframes } from 'styled-components'
import { getColor } from './progressHelpers.js'

const fill = keyframes`
  from {
    width: 0;
  }

  to {
    width: ${({ progress }) => progress}
  }
`

const StyledFiller = styled.div`
	background-color: ${({
		rank,
		theme,
		primaryColor = theme.main,
		secondaryColor = '#414141'
	}) => getColor(rank, primaryColor, secondaryColor)};
	position: absolute;
	border-radius: 50px;
	z-index: ${({ rank }) => rank};
	animation: ${fill} ${({ time }) => `${time}s`};
	width: ${({ progress }) => `${progress}%`};
	height: inherit;
`

const Filler = ({ ...props }) => <StyledFiller {...props} />

export default Filler



// WEBPACK FOOTER //
// ./src/artzu-ui/src/ProgressBar/Filler.js